export const normalizePresetName = (value) => String(value || "").trim().replace(/\s+/g, " ");

export const presetNameKey = (value) => normalizePresetName(value).toLocaleLowerCase();

export const hasPresetName = (presets, candidate) => {
  const candidateKey = presetNameKey(candidate);
  return Boolean(candidateKey) && presets.some((preset) => presetNameKey(preset?.name) === candidateKey);
};
